import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 35,
	viewBox: "0 0 35 35",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 17.5,
		cy: 17.5,
		r: 17,
		stroke: "#003B6F"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M22.6036 9.33398H12.3953C10.7045 9.33398 9.33276 10.7057 9.33276 12.3965V22.6048C9.33276 24.2956 10.7045 25.6673 12.3953 25.6673H18.0524V19.3403H15.9256V16.8733H18.0524V15.0549C18.0524 12.9494 19.3497 11.801 21.2319 11.801C22.1251 11.801 22.9013 11.8648 23.1246 11.8967V14.0979L21.8273 14.1085C20.7959 14.1085 20.6045 14.587 20.6045 15.2995V16.8733H23.0396L22.7206 19.3403H20.6045V25.6673H22.6036C24.2944 25.6673 25.6661 24.2956 25.6661 22.6048V12.3965C25.6661 10.7057 24.2944 9.33398 22.6036 9.33398Z",
		fill: "#003B6F"
	})]
});
export default SvgFacebookIcon;
